<template>
  <div class="top-brand-icons-list">
    <a
      v-for="brand in brands"
      :key="brand.id"
      :href="`/brands/${brand.id}`"
      class="top-brand-icon-link"
      :data-gtm-page="dataGtmPage"
      :data-gtm-click="dataGtmPage ? 'brand' : null"
      :data-gtm-brand-id="dataGtmPage ? brand.id : null"
    >
      <TopBrandIcon :image-url="brand.top_image_url" :alt-text="brand.name" />
    </a>
  </div>
</template>

<script>
import TopBrandIcon from '../../atoms/icons/TopBrandIcon.vue'
export default {
  components: { TopBrandIcon },
  props: {
    brands: {
      type: Array,
      required: true
    },
    dataGtmPage: {
      type: String,
      required: false,
      default: null
    }
  },
  mounted() {
    this.$nextTick(function () {
      this.$emit('mount')
    })
  }
}
</script>

<style lang="scss" scoped>
.top-brand-icons-list {
  @extend %custom-scrollbar;
  display: flex;
  overflow: visible;
}

.top-brand-icon-link {
  &:not(:last-child) {
    margin-right: 8px;
  }
}
</style>
